<template>
	<el-container>
		<div class="colhead">
			<h2 class="header_h2">检查模块管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="检查模块名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		
		</el-header>
		<el-main>
			
			<el-table border ref="multipleTable" tooltip-effect="dark" @select="select" @select-all="select" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="IsValid" label="是否有效" width="60px">
					<template slot-scope="scope">
						<label v-if='scope.row.IsValid=="0"'>否</label>
						<label v-if='scope.row.IsValid=="1"'>是</label>
					</template>
				</el-table-column>
				<el-table-column prop="CheckModuleID" label="检查模块编号" width="200px"></el-table-column>
				<el-table-column prop="CheckModuleName" label="检查模块" width="300px"></el-table-column>
				<el-table-column prop="AdaptSex" label="适用性别" width="100%">
					<template slot-scope="scope">
						<label v-if='scope.row.AdaptSex=="3"'>不限</label>
						<label v-if='scope.row.AdaptSex=="1"'>男</label>
						<label v-if='scope.row.AdaptSex=="2"'>女</label>
					</template>
				</el-table-column>
				<el-table-column prop="CurPrice" label="最低价"></el-table-column>
				<el-table-column prop="OrgPrice" label="原价"></el-table-column>
				<el-table-column prop="ShowOrder" label="排序"></el-table-column>
				<el-table-column prop="EmpName" label="操作员"></el-table-column>
				<el-table-column prop="EmpDate" label="操作时间" width="120px"></el-table-column>
				<el-table-column label="操作" width="120px" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.$index,scope.row)" icon="el-icon-bottom" type="text" size="small">查看</el-button>
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
						<!-- <el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" type="text" size="small">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>

		<!-- ----查看个人信息---- -->
		<el-dialog title="查看信息" :visible.sync="bao1look">
			<el-form :model="LookInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="LookInfo.IsValid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="检查模块编号">
					<el-input  v-model="LookInfo.CheckModuleID"></el-input>
				</el-form-item>
				<el-form-item label="检查模块名称">
					<el-input  v-model="LookInfo.CheckModuleName"></el-input>
				</el-form-item>
				<el-form-item label="适用性别">
				    <el-select v-model="LookInfo.AdaptSex" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in AdaptSex" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<!-- <el-form-item label="适用性别">
					<select style=" width: 100px;  height:30px;" v-model="LookInfo.AdaptSex">
						<option v-for="item in AdaptSex" :value="item.value">
							<h2>{{ item.key }}</h2>
						</option>
					</select>
				</el-form-item> -->
				<el-form-item label="最低价">
					<el-input size="medium" v-model.trim="LookInfo.CurPrice" placeholder="最低价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(LookInfo.CurPrice) ? null : LookInfo.CurPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="原价">
					<el-input size="medium" v-model.trim="LookInfo.OrgPrice" placeholder="原价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(LookInfo.OrgPrice) ? null : LookInfo.OrgPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input v-model.trim="LookInfo.ShowOrder" placeholder="排序号"  @input ="value=value.replace(/[^\d]/g,'')"></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.IsValid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="检查模块编号">
					<el-input  v-model="EditInfo.CheckModuleID"></el-input>
				</el-form-item>
				<el-form-item label="检查模块名称">
					<el-input  v-model="EditInfo.CheckModuleName"></el-input>
				</el-form-item>
				<!-- <el-form-item label="适用性别">
					<select style=" width: 100px;  height:30px;" v-model="EditInfo.AdaptSex">
						<option v-for="item in AdaptSex" :value="item.value">
							<h2>{{ item.key }}</h2>
						</option>
					</select>
				</el-form-item> -->
				<el-form-item label="适用性别">
				    <el-select v-model="EditInfo.AdaptSex" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in AdaptSex" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="最低价">
					<el-input size="medium" v-model.trim="EditInfo.CurPrice" placeholder="最低价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(EditInfo.CurPrice) ? null : EditInfo.CurPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="原价">
					<el-input size="medium" v-model.trim="EditInfo.OrgPrice" placeholder="原价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(EditInfo.OrgPrice) ? null : EditInfo.OrgPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input v-model.trim="EditInfo.ShowOrder" placeholder="排序号"  @input ="value=value.replace(/[^\d]/g,'')"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>
			
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="启用">
					<el-switch v-model="AddInfo.IsValid" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="检查模块编号">
					<el-input  v-model="AddInfo.CheckModuleID"></el-input>
				</el-form-item>
				<el-form-item label="检查模块名称">
					<el-input v-model="AddInfo.CheckModuleName"></el-input>
				</el-form-item>
				<el-form-item label="适用性别">
				    <el-select v-model="AddInfo.AdaptSex" placeholder="请选择" style="width: 100%;">
				      <el-option v-for="item in AdaptSex" :label="item.key" :value="item.value">{{ item.key }}</el-option>
				    </el-select>
				</el-form-item>
				<!-- <el-form-item label="适用性别">
					<select style=" width: 100px;  height:30px;" v-model="AddInfo.AdaptSex">
						<option v-for="item in AdaptSex" :value="item.value">
							<h2>{{ item.key }}</h2>
						</option>
					</select>
				</el-form-item> -->
				<el-form-item label="最低价">
					<el-input size="medium" v-model.trim="AddInfo.CurPrice" placeholder="最低价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(AddInfo.CurPrice) ? null : AddInfo.CurPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="原价">
					<el-input size="medium" v-model.trim="AddInfo.OrgPrice" placeholder="原价" :maxlength="inputMaxL"  @input="inputMaxL = /^\d+\.?\d{0,1}$/.test(AddInfo.OrgPrice) ? null : AddInfo.OrgPrice.length - 1"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input v-model.trim="AddInfo.ShowOrder" placeholder="排序号"  @input ="value=value.replace(/[^\d]/g,'')"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-container>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import CheckModule from '../../apifunction/CheckModule.js'
	export default {
		data() {
			return {
				MyData: [],
				AdaptSex: enums.AdaptSex,
				currentPage: 1,
				pagesize: 10,
				bao1look: false,
				bao1edit: false,
				bao1detele: false,
				bao1newadd: false,
				idx: null,
				deleteAll: [],
				del_list: [],
				//   通过姓名查询
				select_word: "",
				//   定义初始个人信息
				LookInfo: {
					CheckModuleID: '',
					CheckModuleName: '',
					CheckModuleType: '',
					CheckUnitID: '',
					CurPrice: 0,
					FNote: '',
					Mnemsymbol: '',
					OrgPrice: 0,
					ShowOrder: '',
					AdaptSex: '',
					BriefName: '',
					IsValid: '',
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				},
				EditInfo: {
					CheckModuleID: '',
					CheckModuleName: '',
					CheckModuleType: '',
					CheckUnitID: '',
					CurPrice: 0,
					FNote: '',
					Mnemsymbol: '',
					OrgPrice: 0,
					ShowOrder: '',
					AdaptSex: '',
					BriefName: '',
					IsValid: '',
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				},
				AddInfo: {
					CheckModuleID: '',
					CheckModuleName: '',
					CheckModuleType: '',
					CheckUnitID: '',
					CurPrice: 0,
					FNote: '',
					Mnemsymbol: '',
					OrgPrice: 0,
					ShowOrder: '',
					AdaptSex: '0',
					BriefName: '',
					IsValid: '',
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				}
			};
		},
		mounted() {
			this.getAllData();
		},
		methods: {
			//   得到所有的数据---------------
			getAllData() {
				//let user=JSON.parse(JSON.stringify(this.myglobal.userinfo) )
				CheckModule.GetCheckModuleAll()
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data))
					if (ent.Flag=='success') {
						if(ent.Data!='null')
						this.MyData =JSON.parse(ent.Data)
					} else
						this.$message.info(ent.Msg);
				})
				// this.MyData = enums.CheckModuleData;
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 查看
			// 当点击查看时，让dialog显示,同时赋值数据
			handleClick(index, row) {
				this.bao1look = true;
				this.LookInfo = {
					CheckModuleID: row.CheckModuleID,
					CheckModuleName: row.CheckModuleName,
					CheckModuleType: row.CheckModuleType,
					CheckUnitID: row.CheckUnitID,
					CurPrice: row.CurPrice,
					FNote: row.FNote,
					Mnemsymbol: row.Mnemsymbol,
					OrgPrice: row.OrgPrice,
					ShowOrder: row.ShowOrder,
					AdaptSex: row.AdaptSex,
					BriefName: row.BriefName,
					IsValid: row.IsValid,
					EmpID: row.EmpID,
					EmpName: row.EmpName,
					EmpDate: row.EmpDate
				};
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				this.EditInfo = {
					CheckModuleID: row.CheckModuleID,
					CheckModuleName: row.CheckModuleName,
					CheckModuleType: row.CheckModuleType,
					CheckUnitID: row.CheckUnitID,
					CurPrice: row.CurPrice,
					FNote: row.FNote,
					Mnemsymbol: row.Mnemsymbol,
					OrgPrice: row.OrgPrice,
					ShowOrder: row.ShowOrder,
					AdaptSex: row.AdaptSex,
					BriefName: row.BriefName,
					IsValid: row.IsValid,
					EmpID: row.EmpID,
					EmpName: row.EmpName,
					EmpDate: row.EmpDate
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				let user=this.$myglobal.getUserInfo();
				this.EditInfo.EmpID = user.id;
				this.EditInfo.EmpName = user.username;
				this.EditInfo.EmpDate = this.CommonFun.GetNowDateTime();
				
				
				CheckModule.EditCheckModule(this.EditInfo)
				.then( res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.MyData.splice(this.idx,1,this.EditInfo)
						this.bao1edit = false;
						this.$message.success("修改成功");
						
					} else
						this.$message.info(ent.Msg);
				})
				
			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				//this.AddInfo.CheckModuleID=this.CommonFun.NewGuid();
				if(this.AddInfo.CheckModuleID==""||this.AddInfo.CheckModuleName=='')
				{
					this.$message.success("'检查模块编号'和‘检查模块名称’不能为空！");
					return;
				}
				let user=this.$myglobal.getUserInfo();
				this.AddInfo.EmpID = user.id;
				this.AddInfo.EmpName =user.username;
				this.AddInfo.EmpDate = this.CommonFun.GetNowDateTime()();
				this.AddInfo.CorpID = user.corpid;
				CheckModule.AddCheckModule(this.AddInfo)
				.then(res=>{
					let ent=JSON.parse(JSON.stringify(res.data) )
					if (ent.Flag=='success') {
						this.MyData.unshift(this.AddInfo);
						this.bao1newadd = false;
						this.$message.success("新增成功");
						
					} else
						this.$message.info(ent.Msg);
				})
				// this.$refs.AddInfo.validate(valid => {
				// 	if (valid) {
				// 		// 删除尾部数据，并且在头部添加
				// 		//this.data.pop();
				// 		this.data.unshift(this.AddInfo);
				// 		this.bao1newadd = false;
				// 		this.$message.success("新增成功");
				// 	}
				// });
			},
			// 当用户手动勾选数据行的 Checkbox 时触发的事件, 将所有的勾选的数据集中到一个数组中
			select(selection, row) {
				this.deleteAll = selection;
			}
		},
		computed: {
			data() {
				return this.MyData.filter(item => {
					// return item;
					let is_del = false;
					for (let i = 0; i < this.del_list.length; i++) {
						if (item.CheckModuleName === this.del_list[i].CheckModuleName) {
							is_del = true;
							break;
						}
					}
					if (!is_del) {
						if (item.CheckModuleName.indexOf(this.select_word) > -1) {
							return item;
						}
					}
				});
			}
		}
	};
</script>


<style scoped>
	.colhead {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}
	.header_h2{
		color: #333;
		background-color: #f5f5f5;
		border-color: #ddd;
		font-size: 20px;
		text-align: left;
		line-height: 1.7;
		text-align: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
	}
</style>
